import { Component, OnInit } from '@angular/core';
import { DataService } from './../../../services/data.service';

@Component({
  selector: 'app-my-settings-v',
  templateUrl: './my-settings-v.component.html',
  styleUrls: ['./my-settings-v.component.scss']
})
export class MySettingsVComponent implements OnInit {
  userInfo: any;
  constructor(private dataSvc: DataService) { }

  ngOnInit() {
    this.userInfo = this.dataSvc.userDisplayInfo;
    console.log('User data in Client header', this.userInfo.UserRoleID);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-settings-v/my-settings-v.component.ts